import { Spinner } from "@climatepartner/components/Spinner";
import { ReactElement, Suspense } from "react";
import { Outlet } from "react-router-dom";

import { NoTranslateTheme } from "./providers/no-translate-theme";

export { AnalyticsDashboardPage, AnalyticsTestDashboardPage, AnalyticsTestNewDashboardPage } from "./lazy-pages";

export const AnalyticsRoute = (): ReactElement => (
  <NoTranslateTheme>
    <Suspense fallback={<Spinner />}>
      <Outlet />
    </Suspense>
  </NoTranslateTheme>
);
